export * from "/codebuild/output/src3649199585/src/dgbet/local_modules/wallet/index.ts"